export var locales = {
  cs: function cs() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-cs" */'./cs');
  },
  da: function da() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-da" */'./da');
  },
  de: function de() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-de" */'./de');
  },
  en_GB: function en_GB() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-en-GB" */'./en_GB');
  },
  en_ZZ: function en_ZZ() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-en-ZZ" */'./en_ZZ');
  },
  en: function en() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-en" */'./en');
  },
  es: function es() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-es" */'./es');
  },
  fi: function fi() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-fi" */'./fi');
  },
  fr: function fr() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-fr" */'./fr');
  },
  hu: function hu() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-hu" */'./hu');
  },
  it: function it() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-it" */'./it');
  },
  ja: function ja() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-ja" */'./ja');
  },
  ko: function ko() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-ko" */'./ko');
  },
  nb: function nb() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-nb" */'./nb');
  },
  nl: function nl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-nl" */'./nl');
  },
  pl: function pl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-pl" */'./pl');
  },
  pt_BR: function pt_BR() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-pt-BR" */'./pt_BR');
  },
  ru: function ru() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-ru" */'./ru');
  },
  sv: function sv() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-sv" */'./sv');
  },
  th: function th() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-th" */'./th');
  },
  tr: function tr() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-tr" */'./tr');
  },
  uk: function uk() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-uk" */'./uk');
  },
  vi: function vi() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-vi" */'./vi');
  },
  zh_TW: function zh_TW() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-zh-tw" */'./zh_TW');
  },
  zh: function zh() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/link-create-goal-i18n-zh" */'./zh');
  }
};